// apps/web/src/offline/OfflineMemorySyncService.js

import fetch from 'auth/FetchInterceptor'

import OfflineMemoryMatchService from './OfflineMemoryMatchService'

// ======================================================
// SINCRONIZAR PARTIDAS PENDENTES
// ======================================================

const syncPendingMatches =
    async () => {
        const pendingMatches =
            await OfflineMemoryMatchService
                .getPendingMatches()

        if (
            !Array.isArray(
                pendingMatches,
            ) ||
            pendingMatches.length ===
            0
        ) {
            return {
                total:
                    0,

                synced:
                    0,

                failed:
                    0,
            }
        }

        let synced =
            0

        let failed =
            0

        for (
            const match
            of pendingMatches
        ) {
            try {
                if (
                    !match?.gameId
                ) {
                    failed +=
                        1

                    continue
                }

                const result =
                    await fetch({
                        url:
                            `/memory-games/${match.gameId}/matches`,

                        method:
                            'post',

                        silentNetworkError:
                            true,

                        data: {
                            participant:
                                match.participant ||
                                null,

                            completed:
                                Boolean(
                                    match.completed,
                                ),

                            durationMs:
                                Number(
                                    match.durationMs ||
                                    0,
                                ),

                            attempts:
                                Number(
                                    match.attempts ||
                                    0,
                                ),

                            errors:
                                Number(
                                    match.errors ||
                                    0,
                                ),

                            score:
                                Number(
                                    match.score ||
                                    0,
                                ),

                            startedAt:
                                match.startedAt,

                            finishedAt:
                                match.finishedAt,
                        },
                    })

                if (
                    !result?.id
                ) {
                    throw new Error(
                        'MEMORY_SYNC_INVALID_RESPONSE',
                    )
                }

                /*
                 * Só removemos a partida local
                 * depois que a API confirmou
                 * o salvamento.
                 */
                await OfflineMemoryMatchService
                    .removeMatch(
                        match.id,
                    )

                synced +=
                    1

                console.log(
                    '[MEMORY SYNC] Partida sincronizada:',
                    match.id,
                    '->',
                    result.id,
                )
            } catch (
                error
            ) {
                failed +=
                    1

                console.warn(
                    '[MEMORY SYNC] Não foi possível sincronizar:',
                    match?.id,
                    error,
                )
            }
        }

        return {
            total:
                pendingMatches.length,

            synced,

            failed,
        }
    }

// ======================================================
// EXPORT
// ======================================================

const OfflineMemorySyncService = {
    syncPendingMatches,
}

export default OfflineMemorySyncService